module.exports = __webpack_public_path__ + "img/33.83675fb9.png";